import './Home.css';
import { TeamHolder, VSeparator, Opaque, HFlex, VFlex, Left, Link } from '../components/Layout.jsx';
import { ALGO, numLocaleOptionsFull, numLocaleOptions } from '../constants.js';
import { convertObjectSnakeCaseToCamelCase } from '../utils.js';
import constants from '../constants.json';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react-lite';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate, } from 'react-router-dom';
import Team from '../components/Team.jsx';
import D13Icon from '../images/D13.png';
import Socials from '../components/Socials.jsx';

const { rewardsAddress } = convertObjectSnakeCaseToCamelCase(constants);

function Info() {
  return <div className="info-container"> <InfoOutlinedIcon color="inherit" className="info" fontSize="inherit" /> </div>;
}

function SubTitle({ children, ...props }) {
  return <Typography align="center" variant="h2" sx={{mt: 4, mb: 1}}>{children}</Typography>;
}


function B({children}) {
  return <span className="maldini-bold">{children}</span>;
}

function H2({children}) {
  return <Typography variant="h2">{children}</Typography>;
}

function H3({children}) {
  return <Typography sx={{mb: 2}} variant="h3">{children}</Typography>;
}

function Partner({ name, bio, address, nfd, twitter, mobile }) {
  function NfLink({ address, nfd }) {
    return <Link href={`https://app.nf.domains/address/${address}`}>{nfd}</Link>
  }
  if (mobile) {
    return <VFlex sx={{mb: 3}}>
      <Typography sx={{ fontSize: '125%' }}><strong>{name}</strong></Typography>
      <Typography><strong>{bio}</strong></Typography>
      <Left>
        <Typography>Address: <NfLink address={address} nfd={nfd} /></Typography>
        <Typography>Twitter: <Link href={`https://twitter.com/${twitter}`}>@{twitter}</Link></Typography>
      </Left>
    </VFlex>;
  }
  return <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell sx={{textAlign: 'left !important'}}>{bio}</TableCell>
      <TableCell><NfLink address={address} nfd={nfd} /></TableCell>
      <TableCell><Link href={`https://twitter.com/${twitter}`}>@{twitter}</Link></TableCell>
    </TableRow>;
}

function SupNote() {
  return <Link href="#trust-partner-sub"><sup>[1]</sup></Link>
}

export default observer(function({ globalAppState, assets }) {
  const navigate = useNavigate();
  const { ticketDisplay, burnTicket, ticketDisplayAlgo, rewardsPoolAmount, rewardsPoolAmountAlgo } = globalAppState;
  const burnDiscount = 100 - Math.round(burnTicket/ticketDisplay*100);
  const bestTeamWinValue = assets.values().map(({wv}) => wv).sort((a, b) => a<b?-1:1).pop()
  const showcaseTeams = assets.entries().reduce((show, [id, data]) => {
    const { code } = data;
    if (['BRA', 'ARG', 'FRA', 'MAR', 'CRO', 'ESP'].includes(code)) {
      show[code] = data;
    };
    return show;
  }, {});
  const oneToThreePrice = ticketDisplay ? `${ALGO}${ticketDisplayAlgo.toLocaleString(undefined, numLocaleOptions)} - ${(ticketDisplayAlgo * 3).toLocaleString(undefined, numLocaleOptions)}` : `?`;
  return <>

    <VSeparator vh={2} />

    <Opaque h2 op={0.75}>
      <H2><B>World</B> Cup <B>Lottery</B> Sweepstakes</H2>
    </Opaque>

    <VSeparator vh={1} />

    <Opaque h2 op={0.75}>
      <H2>with <B>Verifiable</B> Randomness</H2>
    </Opaque>

    <VSeparator vh={1} />

    <Opaque h2 op={0.75}>
      <H2>On <B>{ALGO}lgorand</B></H2>
    </Opaque>

    <VSeparator vh={{xs: '27vh', md: '33vh' }}/>

    <Opaque sx={{ position: 'relative' }}>
      <HFlex>
        <TeamHolder left={1} top={12}>
          <Team {...showcaseTeams['ARG']} stopOnHover antirotating rotating />
        </TeamHolder>

        <VFlex>
          <H3>Your <B>Stake</B> in the <B>World Cup</B></H3>
          <Left>
            <Typography><strong>CupStakes is a World Cup Lottery Sweepstakes on Algorand.</strong></Typography>
            <Typography>Teams are represented by ARC-19 NFTs called CupStakes.</Typography>
            <Typography>Our <Link href="/#contract">smart contract</Link> uses on-chain verifiable randomness for fair and transparent drawing.</Typography>
            <hr />
            <Typography><strong>Argentina and France CupStakes are redeemable for ALGO:</strong></Typography>
            <Typography>Argentina CupStake holders will share 80% of rewards.</Typography>
            <Typography>France CupStake holders will share 10% of rewards.</Typography>
            <hr />
            <Typography><strong>The rewards pool is kept in a multisig until after the World Cup ends.</strong></Typography>
            <Typography>All admin operations will be audited by our <Link href="#trust">Trust partners</Link> to ensure fairness.</Typography>
            <hr />
            <Typography sx={{mb: 1}}><strong>Holding Argentina or France CupStakes?</strong></Typography>
          </Left>
          <Button onClick={() => navigate("/redeem")} size="big" className="txn-button" variant="outlined">REDEEM NOW</Button>
        </VFlex>

        <TeamHolder right={1} top={12}>
          <Team {...showcaseTeams['FRA']} stopOnHover rotating />
        </TeamHolder>

      </HFlex>
  
    </Opaque>

    <VSeparator vh={{ xs: '5vh', md: '20vh'}} />

    <Opaque sx={{ position: 'relative' }}>
      <HFlex>
        <TeamHolder left={1} top={12}>
          <Team {...showcaseTeams['CRO']} stopOnHover antirotating rotating />
        </TeamHolder>

        <VFlex>
          <H3>How to Play <B>CupStakes</B></H3>
          <HFlex sx={{ width: '100%' }}>
            <HFlex className="landing-box-container" sx={{}}>
              <VFlex className="landing-box">
                <div className="landing-box-title">
                  1/ Pay
                </div>
                <div className="landing-box-line"></div>
                <div>
                  {ALGO} {globalAppState.ticketDisplayAlgo ?? '?'}
                </div>
              </VFlex>
              <div className="landing-box-carret">
                <div className="landing-box-carret-legend">
                  After<br/>10-40s.
                </div>
              </div>
              <VFlex className="landing-box">
                <div className="landing-box-title">
                  2/ Draw
                </div>
                <div className="landing-box-line"></div>
                <HFlex>
                  Teams
                </HFlex>
              </VFlex>
              <div className="landing-box-carret"></div>
              <VFlex className="landing-box">
                <div className="landing-box-title">
                  3/ Collect
                </div>
                <div className="landing-box-line"></div>
                <HFlex>
                  or Burn
                </HFlex>
              </VFlex>
              <div className="landing-box-carret">
                <div className="landing-box-carret-legend">
                  After<br/>22 Dec
                </div>
              </div>
              <VFlex className="landing-box">
                <div className="landing-box-title">
                  9/ Redeem
                </div>
                <div className="landing-box-line"></div>
                <div>
                  🥇 🥈
                </div>
              </VFlex>
              <div className="landing-box-carret invisible"></div>
            </HFlex>
          </HFlex>
          <Left>
            <Typography>1/ Pay for 1 or 3 draws ({oneToThreePrice}), or use a promotional Free Draw ticket.</Typography>
            <Typography>2/ <Link href="/faq#why-does-it-take-up-to-40-seconds-to-draw-a-cupstake">10-40s later,</Link> your Team(s) are drawn for you.</Typography>
            <Typography>3/ Collect the CupStakes NFTs into your wallet, or burn them for a re-draw discount.</Typography>
            <Typography>4/ Rinse and repeat!</Typography>
            <hr />
            <Typography>9/ End up with a Winner or Runner-up CupStake after the Final? <Link href="/faq#how-are-rewards-going-to-be-distributed">Redeem it</Link> for ALGO!</Typography>
            <hr />
            <Typography>CupStakes are available to draw until December 13, 2022, before the first semi-finals match.</Typography>
            <Typography><strong>The <Link href="/audit">ticket price increased</Link> as teams are eliminated and the reward pool grows.</strong></Typography>
          </Left>
        </VFlex>

        <TeamHolder right={1} top={12}>
          <Team {...showcaseTeams['MAR']} stopOnHover rotating />
        </TeamHolder>
      </HFlex>
    </Opaque>

    <VSeparator vh={{ xs: '5vh', md: '10vh'}} />

    <Opaque>
      <H3>Ticket & Rewards pool</H3>
      <Left sx={{minWidth: { lg: '500px' } }}>
        <Typography>Ticket price: {ALGO}{ticketDisplayAlgo}</Typography>
        <Typography>Burn discount: {burnDiscount}%</Typography>
        <hr />
        <Typography>Rewards pool: {ALGO}{rewardsPoolAmountAlgo.toLocaleString(undefined, numLocaleOptions)}</Typography>
        <Typography>Rarest team win value: {ALGO}{bestTeamWinValue?.toLocaleString(undefined, numLocaleOptions)}</Typography>
        <hr />
        <Typography>Ticket price <Link href="/audit">increased</Link> at each team elimination.</Typography>
      </Left>
    </Opaque>

    <VSeparator />

    <Opaque>
      <HFlex>
        <TeamHolder left={1}>
          <Team {...showcaseTeams['BRA']} antirotating stopOnHover rotating />
        </TeamHolder>
        <VFlex>
          <H3>Timeline</H3>
          <Left sx={{minWidth: { lg: '500px' } }}>
            <Typography>Nov 13 &middot; Testnet run</Typography>
            <Typography>Nov 19 &middot; MainNet launch</Typography>
            <Typography>Nov 20 &middot; First World Cup match</Typography>
            <Typography>Dec 13 &middot; CupStakes drawing closes. First semi-final match.</Typography>
            <Typography>Dec 13 &middot; Audit is prepared.</Typography>
            <Typography>Dec 18 &middot; World Cup final</Typography>
            <Typography>Dec 18-22 &middot; Trust partner audit</Typography>
            <Typography>Dec 18-22 &middot; Rewards distribution via smart contract</Typography>
          </Left>
        </VFlex>
        <TeamHolder right={1}>
          <Team {...showcaseTeams['ESP']} stopOnHover rotating />
        </TeamHolder>
      </HFlex>
    </Opaque>

    <VSeparator />

    <Opaque op={0} sx={{ display: { xs: 'flex', md: 'none' }}}>
      <Team {...showcaseTeams['BRA']} stopOnHover rotating />
    </Opaque>

    <VSeparator sx={{ display: { xs: 'flex', md: 'none' }}} />

    <Opaque>
      <H3>Play for Free</H3>
      <Left sx={{ width: { lg: 0.8 } }}>
        <Typography>CupStakes also supports “Free Draw Tickets”, which are special NFTs we created to give away on Discord and Twitter. Operators and partners pay for these tickets in lieu of users, so they contribute to the rewards pool.</Typography>
        <hr />
        <Typography>Participate in our <Link href="https://twitter.com/CupStakes/">Twitter</Link> giveaway challenges to qualify for one. We will also do airdrops of Free Draws to particularly unlucky users!</Typography>
        <hr />
        <Typography>We have given away more than {ALGO}1,000 worth of Free Draw Tickets in the first weeks of the World Cup.</Typography>
      </Left>
    </Opaque>

    <VSeparator vh={{ xs: '5vh', md: '10vh'}} />

    <Opaque id="trust">
      <H3><B>Trust</B> Model</H3>

      <Left sx={{ width: { lg: 0.8 } }}>
        <Typography>Our <Link href="#contract">smart contract</Link> does not hold any user funds or rewards.</Typography>
        <Typography>Instead, the reward pool is a <Link href={`https://algoscan.app/address/${rewardsAddress}`}>5/8 multi-signature wallet</Link>, which is controlled by the CupStakes Trust partners.</Typography>
        <hr />
        <Typography>At least 5 of the partners need to sign off on the CupStakes audit before rewards are moved to the Redeem smart contract for distribution.</Typography>
        <hr />
        <Typography>The Trust partnership exists as a reassurance that the operatation of CupStakes is performed fairly and in good faith.</Typography>
      </Left>
    </Opaque>

    <VSeparator vh={2} />

    <Opaque id="partners">
      <H3>Trust <B>Partners</B></H3>
      <VFlex sx={{mt: 2, mb: 1, display: { xs: 'flex', md: 'none' }}}>
        <Partner
          name="D13.co//ective"
          bio="CupStakes Developers & operators"
          address="DTHIRTEENNLSYGLSEXTXC6X4SVDWMFRCPAOAUCXWIXJRCVBWIIGLYARNQE"
          nfd="d13collective.algo"
          twitter="D13_co"
          mobile={true}
        />
        <Partner
          name={<>Fred Estante <SupNote /></>}
          bio="Head of Product Marketing, Algorand Foundation"
          address="FREDESTDMDNTXKITMO2TEL4ADKHJ7KOQ4HHCX7N65NGTBNLUCWI7W7AMHY"
          nfd="fredestante.algo"
          twitter="FredEstante"
          mobile={true}
        />
        <Partner
          name={<>Nullun <SupNote /></>}
          bio="Developer Relations, Algorand Inc"
          address="XWJ6UN54FCW2P56QFBROUYXNYOU3RXKO6RN7ICM3FZA4JZJ4ZMUVB66ZBQ"
          nfd="nullun.algo"
          twitter="nullun"
          mobile={true}
        />
        <Partner
          name={<>Choppa <SupNote /></>}
          bio="Core community manager, Pact.fi"
          address="WQFL4RWPTTWA5GP2RFBTKYQDW5F3AFXGLVESQUQMAZPPPPCZQS5ECM74BE"
          nfd="choppa.algo"
          twitter="CHOPPAtheSHARK"
          mobile={true}
        />
        <Partner
          name="Zeus.algo"
          bio="Father of the NFT Collector Gods"
          address="ZGW3KIA4KUSRBEFJZQZ2Z5HVHPEWOPMVP4HQ2HVG5LIR57JP6WO4AARWUQ"
          nfd="zeus.algo"
          twitter="zeus_algo"
          mobile={true}
        />
        <Partner
          name="LeavemeaGnome"
          bio="Creator of Orbital Gnome Strikers, Largest NFT Holder on Algorand"
          address="5TOOCJSAZBPBV4LFH26JBJYPJXGQ4XCYAT44Z6ETZT6DHQIEIBTYBYW4CM"
          nfd="gnome.algo"
          twitter="LeavemeaGnome"
          mobile={true}
        />
        <Partner
          name="SaxoSays"
          bio="Blockchain Consultant, Founder of TheHouseofFUD.Com"
          address="QPF3SYXFQK7MVTYZGCJ5JQLQLGA3QMYIOPVMQ3SK2O2IQTYRZUYXQ6EW34"
          nfd="saxosays.algo"
          twitter="SaysSaxo"
          mobile={true}
        />
        <Partner
          name="Farzan Akhtar"
          bio="Blockchain and Beyond podcast host"
          address="FKIJ4VYTHYGVYXQZ73CDHGHMDP2DQKF2V3EFQFSNX5OEFFUKQO6AFGHADY"
          nfd="farzan.algo"
          twitter="FarzanAkhtar1"
          mobile={true}
        />
      </VFlex>

      <Table sx={{display: { xs: 'none', md: 'table' }, maxWidth: { md: 1, lg: 0.9 }}}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Bio</TableCell>
            <TableCell>Address</TableCell>
            <TableCell>Twitter</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <Partner
            name="D13.co//ective"
            bio="CupStakes Developers & operators"
            address="DTHIRTEENNLSYGLSEXTXC6X4SVDWMFRCPAOAUCXWIXJRCVBWIIGLYARNQE"
            nfd="d13collective.algo"
            twitter="D13_co"
          />
          <Partner
            name={<>Fred Estante <SupNote /></>}
            bio="Head of Product Marketing, Algorand Foundation"
            address="FREDESTDMDNTXKITMO2TEL4ADKHJ7KOQ4HHCX7N65NGTBNLUCWI7W7AMHY"
            nfd="fredestante.algo"
            twitter="FredEstante"
          />
          <Partner
            name={<>Nullun <SupNote /></>}
            bio="Developer Relations, Algorand Inc"
            address="XWJ6UN54FCW2P56QFBROUYXNYOU3RXKO6RN7ICM3FZA4JZJ4ZMUVB66ZBQ"
            nfd="nullun.algo"
            twitter="nullun"
          />
          <Partner
            name={<>Choppa <SupNote /></>}
            bio="Core community manager, Pact.fi"
            address="WQFL4RWPTTWA5GP2RFBTKYQDW5F3AFXGLVESQUQMAZPPPPCZQS5ECM74BE"
            nfd="choppa.algo"
            twitter="CHOPPAtheSHARK"
          />
          <Partner
            name="Zeus.algo"
            bio="Father of the NFT Collector Gods"
            address="ZGW3KIA4KUSRBEFJZQZ2Z5HVHPEWOPMVP4HQ2HVG5LIR57JP6WO4AARWUQ"
            nfd="zeus.algo"
            twitter="zeus_algo"
          />
          <Partner
            name="LeavemeaGnome"
            bio="Creator of Orbital Gnome Strikers, Largest NFT Holder on Algorand"
            address="5TOOCJSAZBPBV4LFH26JBJYPJXGQ4XCYAT44Z6ETZT6DHQIEIBTYBYW4CM"
            nfd="gnome.algo"
            twitter="LeavemeaGnome"
          />
          <Partner
            name="SaxoSays"
            bio="Blockchain Consultant, Founder of TheHouseofFUD.Com"
            address="QPF3SYXFQK7MVTYZGCJ5JQLQLGA3QMYIOPVMQ3SK2O2IQTYRZUYXQ6EW34"
            nfd="saxosays.algo"
            twitter="SaysSaxo"
          />
          <Partner
            name="Farzan Akhtar"
            bio="Blockchain and Beyond podcast host"
            address="FKIJ4VYTHYGVYXQZ73CDHGHMDP2DQKF2V3EFQFSNX5OEFFUKQO6AFGHADY"
            nfd="farzan.algo"
            twitter="FarzanAkhtar1"
          />
        </TableBody>
      </Table>

      <Typography id="trust-partner-sub" sx={{ mt: 2, width: '90%', }}>[1] Participating as individuals; not an endorsement by the Algorand Foundation, Algorand inc or Pact.fi</Typography>
    </Opaque>

    <VSeparator vh={{ xs: '5vh', md: '10vh'}} />

    <Opaque>
      <H3>Real-time Data View</H3>
      <Left sx={{ width: { lg: 0.8 } }}>
        <Typography>We are continually evolving our live statistics and global history views for our trust partners and players.</Typography>
        <Typography>You can already see every significant action that happens on CupStakes! Check the Statistics and every draw on the <Link href="/data/#global-history">Data Page</Link>.</Typography>
        <Typography>Your Account page includes a <Link href="/data/#history">personal audit</Link> with all of your draws.</Typography>
        <Typography>We are working on a "VRF Draw Proof" explanation view for every single CupStakes draw execution.</Typography>
      </Left>
    </Opaque>

    <VSeparator />

    <Opaque id="contract">
      <H3>Open Source Contract</H3>
      <Left sx={{ width: { lg: 0.8 } }}>
        <Typography>Our <Link href="https://github.com/CupStakes/cupstakes-smart-contracts">draw smart-contract</Link> is open sourced and extensively documented on Github. It has been informally audited by our Trust Partner @nullun and has the added benefit of not holding the rewards pool.</Typography>
        <hr />
        <Typography>The permissive MIT license will allow anyone to remix our logic and execute their own lotteries with relatively little effort.</Typography>
        <hr />
        <Typography>You can find answers about the mechanics of drawing in the <Link href="/faq">Frequently Asked Questions </Link>section.</Typography>
      </Left>
    </Opaque>

    <VFlex sx={{ minHeight: '10vh' }}>
      <Box sx={{animation: 'fade-pulse 6s linear infinite, logo-in 15s linear forwards', mixBlendMode: 'difference'}}>
        <Link href="https://d13.co/">
          <img src={D13Icon} />
        </Link>
      </Box>
    </VFlex>

    <Opaque id="socials">
      <H3>Get in touch</H3>
      <Socials />
    </Opaque>

    <VSeparator />
  </>;
});



     //  <!-- <Typography>Our white-paper outlining the design of CupStakes in more detail can be found <Link href="https://d13.co/uploads/temp/algofam/cupstakes.pdf">[here]</Link></Typography> -->
/*
    <VSeparator />

    <Opaque>
      <H3>Affiliations &amp; Endorsements</H3>
      <Left>
        <Typography>Our Trust partners act as individuals and their participation should not be considered an endorsement by their respective employers or organisations</Typography>
        <Typography>CupStakes is not affiliated with FIFA, the Algorand Foundation or Algorand inc.</Typography>
        <Typography>CupStakes does not misuse any registered trademarks.</Typography>
      </Left>
    </Opaque>
          */
